module.exports = __webpack_public_path__ + "img/WAVE.90fe5fb7.jpg";